/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { NbThemeService } from '@nebular/theme';
import { NbAuthService } from '@nebular/auth';
import { ApiService } from './providers/Api';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(private analytics: AnalyticsService, private themeService: NbThemeService,
      private authService: NbAuthService, private api: ApiService) {
      this.themeService.changeTheme('corporate');
  }

  ngOnInit(): void {
      if (localStorage.getItem('loggedUser')) {
          this.analytics.trackPageViews();
      } else {
          const token: any = this.authService.getToken();
          if (token.value.token) {
              this.api.setToken(token.value.token);
          } else {
              location.href = '/#/auth/login';
          }
      }
  }
}
